import React from "react";
import { ShieldCheckIcon } from "lucide-react";
import { CtaButton } from "../CtaButton";
const reviewList = ["Open the six volumes.", "Review the clinical cases.", "Look through the checklists.", "Explore the reasoning maps.", "Use the practical tools."];
export function Guarantee() {
  return <section className="bg-white py-16 sm:py-20" aria-labelledby="guarantee-title" data-id="element-155" data-mp="29eyjkw0y9isx">
      <div className="mx-auto max-w-3xl px-5 text-center" data-id="element-156" data-mp="2edt1lvr3f3bz">
        <div className="mx-auto flex h-24 w-24 flex-col items-center justify-center rounded-full border-4 border-brand bg-brand-light text-brand" data-id="element-157" data-mp="2efdw5ldeqm9u">
          <ShieldCheckIcon className="h-8 w-8" aria-hidden="true" data-id="element-158" data-mp="2oc8tw21uwin2" />
          <span className="mt-0.5 text-xs font-black uppercase" data-id="element-159" data-mp="2scsszb5zpwbu">7 days</span>
        </div>
        <h2 id="guarantee-title" className="mt-6 font-display text-[32px] font-black leading-tight text-ink sm:text-[44px]" data-id="element-160" data-mp="tx67wec0niow">
          Try it for <em className="text-brand" data-id="element-161" data-mp="xxzyxgkr9dm0">7 days</em>
        </h2>
        <p className="mx-auto mt-4 max-w-xl text-[17px] leading-relaxed text-muted" data-id="element-162" data-mp="y0kyfyxkzhgl">
          I want you to be able to look through everything before deciding if it's right for you.
        </p>

        <ul className="mx-auto mt-6 max-w-sm space-y-2 text-left" data-id="element-163" data-mp="3nsvhykz399y1">
          {reviewList.map(item => <li key={item} className="flex items-center gap-3 text-[16px] font-semibold text-ink" data-id="element-164" data-mp="3dwk6fx7boo4n">
              <span className="h-2 w-2 shrink-0 rounded-full bg-brand" aria-hidden="true" data-id="element-165" data-mp="fewlzjc49okj" />
              {item}
            </li>)}
        </ul>

        <p className="mx-auto mt-6 max-w-xl text-[16px] leading-relaxed text-muted" data-id="element-166" data-mp="agd17m99eitr">
          If you decide within 7 days that the Safe Spine Method™ isn't valuable for your professional learning and
          organization process, you can request a refund according to the purchase terms.
        </p>
        <p className="mt-4 text-[16px] font-bold text-ink" data-id="element-167" data-mp="2q8izgspslfrc">
          No complicated process · No long-term commitment · No monthly payments
        </p>

        <div className="mt-10" data-id="element-168" data-mp="1d7wbavkdtoi0">
          <CtaButton label="Try it risk-free" caption="Protected by the 7-day guarantee" data-id="element-169" data-mp="1d9qw89vnlgm3" />
        </div>
      </div>
    </section>;
}